import { z } from 'zod';
import { eventSchema } from './envelope';

export const DOCUMENTS_REMINDER_REQUESTED_V1 = 'documents.reminder.requested.v1' as const;

/**
 * Een herinnering voor wie een versie nog niet bevestigde (Extra 6, punt 4).
 *
 * Dezelfde vorm als `reach.reminder.requested.v1` en bewust niet hetzelfde event: dat draagt een
 * `postId`, en een document is geen bericht. Twee modules die één event delen omdat het toevallig
 * dezelfde velden heeft, lopen uiteen zodra er bij de ene iets bijkomt.
 *
 * `documents` stuurt zelf niets: het zegt wie er een herinnering hoort te krijgen, en
 * `notifications` beslist langs welk kanaal dat gaat (ADR-0021).
 */
export const documentsReminderRequestedV1Schema = eventSchema({
  versionId: z.guid(),
  documentId: z.guid(),
  /** De titel van het document, niet van de versie: dat is wat de medewerker herkent. */
  title: z.string(),
  personIds: z.array(z.guid()),
});
export type DocumentsReminderRequestedV1 = z.infer<typeof documentsReminderRequestedV1Schema>;
